import React, { useCallback, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../utils/adminApi";
import "./Models.css";

/* ================= HELPERS ================= */

const getImageSrc = (value = "") => {
  const src = String(value || "").trim();
  if (!src) return "";
  if (
    src.startsWith("data:") ||
    src.startsWith("http://") ||
    src.startsWith("https://")
  ) {
    return src;
  }
  return `${API_BASE_URL}/${src.replace(/^\/+/, "")}`;
};

const normalize = (value = "") =>
  String(value || "").toLowerCase().replace(/\s+/g, " ").trim();

/* ================= COMPONENT ================= */

const Models = () => {
  const { brand } = useParams();
  const navigate = useNavigate();

  const decodedBrand = decodeURIComponent(brand || "").trim();

  const [models, setModels] = useState([]);
  const [brandName, setBrandName] = useState(decodedBrand);
  const [loading, setLoading] = useState(true);

  const fetchModels = useCallback(async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/models`);

      const selectedBrandLower = normalize(decodedBrand);
      const looksLikeObjectId = /^[a-f\d]{24}$/i.test(decodedBrand);

      const filtered = (Array.isArray(res.data) ? res.data : []).filter(
        (m) => {
          const modelBrandName = normalize(m.brandId?.name || "");
          const modelBrandId = String(m.brandId?._id || "");

          return (
            modelBrandName === selectedBrandLower ||
            (looksLikeObjectId && modelBrandId === decodedBrand)
          );
        }
      );

      setModels(filtered);

      if (filtered.length > 0) {
        setBrandName(filtered[0].brandId?.name || decodedBrand);
      }
    } catch (error) {
      console.error("Model fetch error:", error);
    } finally {
      setLoading(false);
    }
  }, [decodedBrand]);

  useEffect(() => {
    fetchModels();
  }, [fetchModels]);

  return (
    <div className="model-page-wrapper">
      <div className="model-header">
        <div className="header-nav">
          <button className="back-btn" onClick={() => navigate(-1)}>
            Back
          </button>
        </div>

        <h1>
          Select <span>{brandName}</span> Model
        </h1>
      </div>

      {loading && <p className="no-results">Loading models...</p>}

      {!loading && (
        <div className="model-grid">
          {models.length === 0 && (
            <p className="no-results">No models found.</p>
          )}

          {models.map((model, index) => (
            <div
              key={model._id}
              className="model-card-premium"
              style={{ "--index": index, "--brand-accent": "#007AFF" }}
              onClick={() =>
                navigate(
                  `/book/${encodeURIComponent(
                    brandName
                  )}/${encodeURIComponent(model.name)}`
                )
              }
            >
              <div className="model-card-content">
                {model.image && (
                  <div className="model-visual">
                    <img src={getImageSrc(model.image)} alt={model.name} />
                  </div>
                )}

                <div className="model-info">
                  <h3>{model.name}</h3>
                  {/* <button type="button" className="select-btn">
                    Select
                  </button> */}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Models;
